// import * as constants from 'helper/constants';
import React, { PureComponent } from 'react';
import check from 'assets/check.svg';
import queryString from 'qs';
import strings from 'helper/localization/localization';

const styles = {
  checkStyle: {
    height: '14vh',
    minHeight: '50px',
    maxHeight: '104px',
  },
  colStyle: {
    maxWidth: '100%',
  },
  titleStyle: {
    letterSpacing: '1px',
  },
  textStyle: {
    lineHeight: '1.4',
    letterSpacing: '0.1px',
    marginBottom: '0px',
  },
  rowStyle: {
    margin: '0',
  },
  rowIconStyle: {
    textAlign: 'center',
    display: 'block',
    margin: '5.5vh 0 0 0',
  },
};

export default class AccountConfirmation extends PureComponent {
  constructor(props) {
    super(props);

    this.api = this.props.api;

    const link = window.location.search.split('?');
    this.query = queryString.parse(link[1]);
  }

  componentDidMount() {
    let confirmationToken;

    if (this.query) {
      confirmationToken = this.query.token;

      this.api.confirmUser({ confirmationToken }, () => {});
    }
  }

  render() {
    // target is set to email if the user is just changing their email address
    const oldAccountNewEmail = (this.query && this.query.target === 'email');

    const titleString = oldAccountNewEmail ?
      strings.youHaveChangedYourEmail :
      strings.youHaveConfirmedYourEmail;
    const headingString = oldAccountNewEmail ?
      strings.returnToYourMimiApp :
      strings.closeBrowserEnjoyMimi;

    return (
      <div className="container">
        <div style={styles.rowStyle} className="row mb-3">
          <div style={styles.colStyle} className="col-md-offset-3">
            <h2 style={styles.titleStyle}>{titleString}</h2>
            <h5 style={styles.textStyle}>{headingString}</h5>
          </div>
        </div>
        <div className="row mb-3" style={styles.rowIconStyle}>
          <div style={styles.colStyle} className="col-md-offset-3 socialContainer">
            <img src={check} alt="check" className="check-icon" style={styles.checkStyle} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/accountManagement/AccountConfirmation.jsx